/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Idea_Language_IdInputs */

const en_idea_language_id = /** @type {(inputs: Idea_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

const id_idea_language_id = /** @type {(inputs: Idea_Language_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bahasa Indonesia`)
};

/**
* | output |
* | --- |
* | "Bahasa Indonesia" |
*
* @param {Idea_Language_IdInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const idea_language_id = /** @type {((inputs?: Idea_Language_IdInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Idea_Language_IdInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_idea_language_id(inputs)
	return en_idea_language_id(inputs)
});